import {
  CalculatorProps,
  FormValues,
  getOnDownloadFileClick,
  getOnShareClick,
  PlatformType,
  State,
} from '@sbercloud/uikit-product-calculator';
import { useCallback } from 'react';
import { backendHost } from 'src/global';
import { useAnalytics } from 'src/hooks/useAnalytics';

import { connectProduct } from '../utils/connectProduct';

const onDownloadFileClickFn = getOnDownloadFileClick(backendHost);
const onShareClickFn = getOnShareClick({
  backendHost,
  baseUrl: process.env.CONTENT_BASE_URL,
});

export function useActions(): CalculatorProps['actions'] {
  const { sendAnalytics } = useAnalytics();

  const onPlatformSelect = useCallback(
    (platformId: PlatformType) => {
      const ymData = {
        Calculator: {
          [window.location.href.split('?')[0]]: {
            'choose-platform': 'Calculator-choose-platform-' + platformId,
          },
        },
      };
      sendAnalytics({}, ymData, 'Calculator-choose-platform');
    },
    [sendAnalytics],
  );

  const onCatalogOpen = useCallback(() => {
    const ymData = {
      Calculator: {
        [window.location.href.split('?')[0]]: { catalog: 'Calculator-catalog' },
      },
    };
    sendAnalytics({}, ymData, 'Calculator-catalog');
  }, [sendAnalytics]);

  const onDownloadFileClick = useCallback(
    async (state: State) => {
      const ymData = {
        Calculator: {
          [window.location.href.split('?')[0]]: {
            download: 'Calculator-download',
          },
        },
      };
      sendAnalytics({}, ymData, 'Calculator-download');

      onDownloadFileClickFn(state);
    },
    [sendAnalytics],
  );

  const onShareClick = useCallback(
    async (state: State) => {
      const ymData = {
        Calculator: {
          [window.location.href.split('?')[0]]: { share: 'Calculator-share' },
        },
      };
      sendAnalytics({}, ymData, 'Calculator-share');

      onShareClickFn(state);
    },
    [sendAnalytics],
  );

  const onConnectClick = useCallback(
    (productType: string, value: FormValues) => {
      const ymData = {
        Calculator: {
          [window.location.href.split('?')[0]]: {
            connect: 'Calculator-connect-' + productType,
          },
        },
      };
      sendAnalytics({}, ymData, 'Calculator-connect');

      connectProduct(productType, value);
    },
    [sendAnalytics],
  );

  const onRequestConsultationClick = useCallback(() => {
    const ymData = {
      Calculator: {
        [window.location.href.split('?')[0]]: {
          consultation: 'Calculator-consultation',
        },
      },
    };
    sendAnalytics({}, ymData, 'Calculator-consultation');
  }, [sendAnalytics]);

  const onProductDelete = useCallback(
    (productId: string) => {
      const ymData = {
        Calculator: {
          [window.location.href.split('?')[0]]: {
            'delete-product': 'Calculator-delete-product-' + productId,
          },
        },
      };
      sendAnalytics({}, ymData, 'Calculator-delete-product');
    },
    [sendAnalytics],
  );

  const onProductSelect = useCallback(
    (productId: string) => {
      const ymData = {
        Calculator: {
          [window.location.href.split('?')[0]]: {
            'choose-product': 'Calculator-choose-product-' + productId,
          },
        },
      };
      sendAnalytics({}, ymData, 'Calculator-choose-product');
    },
    [sendAnalytics],
  );

  const onStartClick = useCallback(() => {
    const ymData = {
      Calculator: {
        [window.location.href.split('?')[0]]: {
          start: 'Calculator-start',
        },
      },
    };
    sendAnalytics({}, ymData, 'Calculator-start');
  }, [sendAnalytics]);

  return {
    onCatalogOpen,
    onPlatformSelect,
    onShareClick,
    onDownloadFileClick,
    onConnectClick,
    onRequestConsultationClick,
    onProductDelete,
    onProductSelect,
    onStartClick,
  };
}
